// libs
import { css } from '@emotion/css';

export const filledIconStyles = css`
  color: var(--yellow-500);
`;

export const CLASSES = {
  icon: 'transform-none',
  iconEmpty: 'text-icon-placeholder',
  iconFilled: filledIconStyles,
};
